
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","id":"Headphones-Plug--Streamline-Streamline--3.0.svg","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('desc',[_v('Headphones Plug Streamline Icon: https://streamlinehq.com')]),_c('defs'),_c('title',[_v('headphones-plug')]),_c('path',{attrs:{"d":"m6.741 10.305 3.722 -3.722s1.06 -1.06 2.12 0l3.183 3.182s1.06 1.06 0 2.122l-3.722 3.721s-1.06 1.06 -2.12 0L6.74 12.426s-1.06 -1.06 0 -2.121","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m12.584 6.583 3.182 -3.182 3.182 3.182 -3.182 3.182Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m21.599 0.75 -2.121 2.121","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M20.237 4.434a0.75 0.75 0 0 0 -0.112 -0.916l-1.294 -1.293a0.749 0.749 0 0 0 -0.916 -0.113L15.766 3.4l3.182 3.182Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M7.6 17.928a1.5 1.5 0 0 1 -2.121 0l-1.058 -1.061a1.5 1.5 0 0 1 0 -2.121l2.32 -2.32 3.182 3.182Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m4.952 17.4 -1.965 2.157a1.5 1.5 0 0 0 -0.147 2.251l0.912 1a1.5 1.5 0 0 0 2.122 0l1.06 -1.152a1.5 1.5 0 0 1 2.122 0l1.591 1.591","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    